var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestEthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 58 58",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 28,
    stroke: "#52555b",
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeDasharray: "5 5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.889 28.924l10.498 6.066 10.493-6.066-10.493-17.035-10.498 17.035z",
    fill: "#52555b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.889 30.87l10.498 14.463L39.889 30.87l-10.502 6.066-10.498-6.066z",
    fill: "#52555b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestEthIcon);
export default __webpack_public_path__ + "static/media/test_eth_icon.17678d492c2aa37240cbab9324fd12b3.svg";
export { ForwardRef as ReactComponent };